import { IOrderDetail } from '@/shared/model/order/order-detail.model';
import { IRestaurantCategory } from '@/shared/model/restaurant-category.model';
import { IRestaurantWorkingTimes, RestaurantWorkingTimes } from '@/shared/model/restaurant-working-times.model';
import { IDeliverySpec } from '@/shared/model/delivery-spec.model';
import { IDiscount } from '@/shared/model/discount.model';
import { IRating } from '@/shared/model/rating.model';
import { IRestaurant, Restaurant } from '@/shared/model/restaurant.model';
import { IUser } from '@/shared/model/user.model';
import { ActionTree } from 'vuex';
import { RootState } from '../types';
import { IMenuCategory } from '@/shared/model/menu-category.model';
import { ICustomer } from '@/shared/model/customer.model';
import { IMarketer } from '@/shared/model/marketer.model';
import JhiDataUtils from '@/shared/data/data-utils.service';
import RestaurantService from '@/shared/services/restaurant.service';
import { IRestaurantStore } from './types';
import RestaurantCategoryService from '@/shared/services/restaurant-category.service';
import RestaurantWorkingTimesService from '@/shared/services/restaurant-working-times.service';
import DeliverySpecService from '@/shared/services/delivery-spec.service';
import { Vue } from 'vue-property-decorator';

const jhiDataUtils = new JhiDataUtils();
const restaurantService = new RestaurantService();
const restaurantCategoryService = new RestaurantCategoryService();
const restaurantWorkingTimesService = new RestaurantWorkingTimesService();
const deliverySpecService = new DeliverySpecService();

const maxFileSizes = {
  logo: 0.15,
  image: 1,
  menuCard: 1,
  idCard: 0.15,
  cocRegistration: 0.15,
  bankCard: 0.15,
};

const checkAllFilesAreImage = (files: File[]): boolean => {
  return files.every(file => new RegExp('^image/').test(file.type));
};

const elementsInArraytoBase64 = (files: File[]): Promise<any> => {
  return new Promise(resolve => {
    const base64Data = [];
    files.forEach(file => {
      jhiDataUtils.toBase64(file, res => {
        base64Data.push(res);
        base64Data.length === files.length && resolve(base64Data);
      });
    });
  });
};

export const actions: ActionTree<IRestaurantStore, RootState> = {
  setRestaurant({ commit }, newRestaurant: IRestaurant) {
    commit('setRestaurant', newRestaurant);
  },
  setId({ commit }, newId: number): void {
    commit('setId', newId);
  },
  setName({ commit }, newName: string): void {
    commit('setName', newName);
  },
  setLogoContentType({ commit }, newLogoContentType: string): void {
    commit('setLogoContentType', newLogoContentType);
  },
  setLogo({ commit }, newLogo: string): void {
    commit('setLogo', newLogo);
  },
  setImageContentType({ commit }, newImageContentType: string): void {
    commit('setImageContentType', newImageContentType);
  },
  setImage({ commit }, newImage: string): void {
    commit('setImage', newImage);
  },
  setZipcode({ commit }, newZipcode: string): void {
    commit('setZipcode', newZipcode);
  },
  setStreet({ commit }, newStreet: string): void {
    commit('setStreet', newStreet);
  },
  setAddressAddition({ commit }, newAddressAddition: string): void {
    commit('setAddressAddition', newAddressAddition);
  },
  setNumber({ commit }, newNumber: string): void {
    commit('setNumber', newNumber);
  },
  setCity({ commit }, newCity: string): void {
    commit('setCity', newCity);
  },
  setPhone({ commit }, newPhone: string): void {
    commit('setPhone', newPhone);
  },
  setRegisterNumber({ commit }, newRegisterNumber: string): void {
    commit('setRegisterNumber', newRegisterNumber);
  },
  setTaxIdentificationNumber({ commit }, newTaxIdentificationNumber: string): void {
    commit('setTaxIdentificationNumber', newTaxIdentificationNumber);
  },
  setDeliver({ commit }, newDeliver: boolean): void {
    commit('setDeliver', newDeliver);
  },
  setPickup({ commit }, newPickup: boolean): void {
    commit('setPickup', newPickup);
  },
  setBankAccountName({ commit }, newBankAccountName: string): void {
    commit('setBankAccountName', newBankAccountName);
  },
  setIbanNumber({ commit }, newIbanNumber: string): void {
    commit('setIbanNumber', newIbanNumber);
  },
  setPep({ commit }, newPep: boolean): void {
    commit('setPep', newPep);
  },
  setEnabled({ commit }, newEnabled: boolean): void {
    commit('setEnabled', newEnabled);
  },
  setStartingDate({ commit }, newStartingDate: Date): void {
    commit('setStartingDate', newStartingDate);
  },
  setStartingDateString({ commit }, newStartingDateString: string): void {
    commit('setStartingDateString', newStartingDateString);
  },
  setDomain({ commit }, newDomain: boolean): void {
    commit('setDomain', newDomain);
  },
  setMenuCard({ commit }, newMenuCard: string): void {
    commit('setMenuCard', newMenuCard);
  },
  setMenuCardContentType({ commit }, newMenuCardContentType: string): void {
    commit('setMenuCardContentType', newMenuCardContentType);
  },
  setMenuCardPath({ commit }, newMenuCardPath: string): void {
    commit('setMenuCardPath', newMenuCardPath);
  },
  setIdCard({ commit }, newIdCard: string): void {
    commit('setIdCard', newIdCard);
  },
  setIdCardContentType({ commit }, newIdCardContentType: string): void {
    commit('setIdCardContentType', newIdCardContentType);
  },
  setIdCardPath({ commit }, newIdCardPath: string): void {
    commit('setIdCardPath', newIdCardPath);
  },
  setCocRegistration({ commit }, newCocRegistration: string): void {
    commit('setCocRegistration', newCocRegistration);
  },
  setCocRegistrationContentType({ commit }, newCocRegistrationContentType: string): void {
    commit('setCocRegistrationContentType', newCocRegistrationContentType);
  },
  setCocRegistrationPath({ commit }, newCocRegistrationPath: string): void {
    commit('setCocRegistrationPath', newCocRegistrationPath);
  },
  setbankCard({ commit }, newbankCard: string): void {
    commit('setbankCard', newbankCard);
  },
  setbankCardContentType({ commit }, newbankCardContentType: string): void {
    commit('setbankCardContentType', newbankCardContentType);
  },
  setbankCardPath({ commit }, newbankCardPath: string): void {
    commit('setbankCardPath', newbankCardPath);
  },
  setUser({ commit }, newUser: IUser): void {
    commit('setUser', newUser);
  },
  setFoodDiscount({ commit }, newFoodDiscount: IDiscount): void {
    commit('setFoodDiscount', newFoodDiscount);
  },
  setNonfoodDiscount({ commit }, newNonfoodDiscount: IDiscount): void {
    commit('setNonfoodDiscount', newNonfoodDiscount);
  },
  setRatings({ commit }, newRatings: IRating[]): void {
    commit('setRatings', newRatings);
  },
  setDeliverySpecs({ commit }, newDeliverySpecs: IDeliverySpec[]): void {
    commit('setDeliverySpecs', newDeliverySpecs);
  },
  addDeliverySpec({ commit }): void {
    commit('addDeliverySpec');
  },
  removeDeliverySpec({ commit }, i: number): void {
    commit('removeDeliverySpec', i);
  },
  setRestaurantWorkingTimes({ commit }, newRestaurantWorkingTimes: IRestaurantWorkingTimes[]): void {
    commit('setRestaurantWorkingTimes', newRestaurantWorkingTimes);
  },
  addRestaurantWorkingTime({ commit }, payload): void {
    commit('addRestaurantWorkingTime', payload);
  },
  removeRestaurantWorkingTime({ commit }, i: number): void {
    commit('removeRestaurantWorkingTime', i);
  },
  removeShift({ commit }, payload): void {
    commit('removeShift', payload);
  },
  setMenuCategories({ commit }, newMenuCategories: IMenuCategory[]): void {
    commit('setMenuCategories', newMenuCategories);
  },
  setRestaurantCategories({ commit }, newRestaurantCategories: IRestaurantCategory[]): void {
    commit('setRestaurantCategories', newRestaurantCategories);
  },
  setCustomer({ commit }, newCustomer: ICustomer): void {
    commit('setCustomer', newCustomer);
  },
  setMarketer({ commit }, newMarketer: IMarketer): void {
    commit('setMarketer', newMarketer);
  },
  setDateOfBirth({ commit }, newDateOfBirth: Date): void {
    commit('setDateOfBirth', newDateOfBirth);
  },
  updateRestaurantStateMember({ commit }, payload): void {
    commit('updateRestaurantStateMember', payload);
  },
  async retrieveUser({ dispatch, commit, rootGetters }): Promise<boolean> {
    try {
      const restaurant = await restaurantService.findByUserId(rootGetters.account.id);
      commit('setRestaurant', restaurant);
      const deliverySpecs = await deliverySpecService.getDeliverySpecs(restaurant.id);
      commit('setDeliverySpecs', deliverySpecs);
      const restaurantWorkingTimes = await restaurantWorkingTimesService.getRestaurantWorkingTimes(restaurant.id);
      commit('setRestaurantWorkingTimes', restaurantWorkingTimes);
      const restaurantCategories = await restaurantCategoryService.getRestaurantCategories(restaurant.id);
      commit('setRestaurantCategories', restaurantCategories);
      dispatch('retrieveOrders');
      return true;
    } catch (error) {
      if (error.response.status === 404) {
        return false;
      } else {
        throw error;
      }
    }
  },
  async retrieveOrders({ commit, dispatch, state }) {
    return new Promise<boolean>(resolve => {
      restaurantService.getReadyOrders(state.restaurant.id).then(res => {
        commit('setReadyOrders', res);
        resolve(true);
      });
    });
  },
  async setFile({ commit }, { field, file }: { field: string; file: File }) {
    const base64Data: IRestaurant = await jhiDataUtils.setFileData(file, new Restaurant(), field);
    setTimeout(() => {
      commit(`set${field.charAt(0).toUpperCase() + field.slice(1)}`, base64Data[`${field}`]);
      commit(`set${field.charAt(0).toUpperCase() + field.slice(1)}ContentType`, base64Data[`${field}ContentType`]);
    }, 100);
  },
  async setMultipleFiles({ commit }, { field, files, supportPage }: { field: string; files: File[]; supportPage: boolean }) {
    if (checkAllFilesAreImage(files)) {
      const base64Data = await elementsInArraytoBase64(files);
      if (supportPage) {
        commit(`supportStore/set${field.charAt(0).toUpperCase() + field.slice(1)}`, base64Data, { root: true });
        commit(`supportStore/set${field.charAt(0).toUpperCase() + field.slice(1)}ContentType`, files[0].type, { root: true });
      } else {
        commit(`set${field.charAt(0).toUpperCase() + field.slice(1)}`, base64Data);
        commit(`set${field.charAt(0).toUpperCase() + field.slice(1)}ContentType`, files[0].type);
      }
      return { ok: true };
    } else if (files.length === 1 && files[0].type === 'application/pdf') {
      const base64Data = await elementsInArraytoBase64(files);
      if (supportPage) {
        commit(`supportStore/set${field.charAt(0).toUpperCase() + field.slice(1)}`, base64Data, { root: true });
        commit(`supportStore/set${field.charAt(0).toUpperCase() + field.slice(1)}ContentType`, files[0].type, { root: true });
      } else {
        commit(`set${field.charAt(0).toUpperCase() + field.slice(1)}`, base64Data);
        commit(`set${field.charAt(0).toUpperCase() + field.slice(1)}ContentType`, files[0].type);
      }
      return { ok: true };
    } else {
      const pdf = files.find(file => file.type === 'application/pdf');
      return { ok: false, pdf };
    }
  },
  setTab({ commit }, newTab: string): void {
    commit('setTab', newTab);
  },
  setDrawer({ commit }, newDrawer: boolean): void {
    commit('setDrawer', newDrawer);
  },
  setProvideNow({ commit }, newProvideNow: boolean): void {
    commit('setProvideNow', newProvideNow);
  },
  setNotFound({ commit }, newNotFound: string): void {
    commit('setNotFound', newNotFound);
  },
  setPause({ commit }, newPause: boolean): void {
    commit('setPause', newPause);
  },
  setWorkingTimes({ commit }, newWorkingTimes: IRestaurantWorkingTimes[]): void {
    commit('setWorkingTimes', newWorkingTimes);
  },
  createWorkingTimesShell({ commit }): void {
    const workingTimes = [];
    for (let i = 1; i < 8; i++) {
      const workingTime = [new RestaurantWorkingTimes(null, i), new RestaurantWorkingTimes(null, i)];
      workingTimes.push(workingTime);
    }
    commit('setWorkingTimes', workingTimes);
  },
  createWorkingTimesShellFromData(
    { commit, rootGetters, dispatch },
    { toEdit, restaurant }: { toEdit: boolean; restaurant: boolean }
  ): void {
    const workingTimes = [[], [], [], [], [], [], []];
    let restaurantWorkingTimes: IRestaurantWorkingTimes[] = null;

    if (!toEdit) {
      restaurantWorkingTimes = rootGetters['supportStore/getNewRestaurant'].restaurantWorkingTimes;
    } else if (!restaurant) {
      restaurantWorkingTimes = rootGetters['supportStore/getRestaurant'].restaurantWorkingTimes;
    } else {
      restaurantWorkingTimes = rootGetters['restaurantStore/getRestaurant'].restaurantWorkingTimes;
    }

    restaurantWorkingTimes.forEach(wt => {
      wt.deliverFromHourString = wt.deliverFromHour && Vue.filter('formatTime')(wt.deliverFromHour);
      wt.deliverToHourString = wt.deliverToHour && Vue.filter('formatTime')(wt.deliverToHour);
      wt.pickupFromHourString = wt.pickupFromHour && Vue.filter('formatTime')(wt.pickupFromHour);
      wt.pickupToHourString = wt.pickupToHour && Vue.filter('formatTime')(wt.pickupToHour);

      if (!workingTimes[wt.day - 1]) return;

      if (workingTimes[wt.day - 1].length < 1 || !workingTimes[wt.day - 1][0]) {
        workingTimes[wt.day - 1][0] = wt;
      } else {
        if (new Date(workingTimes[wt.day - 1][0].deliverFromHour).getTime() < new Date(wt.deliverFromHour).getTime()) {
          workingTimes[wt.day - 1][1] = wt;
        } else {
          workingTimes[wt.day - 1][1] = { ...workingTimes[wt.day - 1][0] };
          workingTimes[wt.day - 1][0] = wt;
        }
      }
    });

    let pause = false;

    workingTimes.forEach((wt, i) => {
      if (wt.length === 2) {
        pause = true;
      } else {
        wt.length < 2 && wt.push(new RestaurantWorkingTimes(null, i + 1));
        wt.length < 2 && wt.push(new RestaurantWorkingTimes(null, i + 1));
      }
    });
    dispatch('setPause', pause);
    commit('setWorkingTimes', workingTimes);
  },
  shellPropertyChanged({ commit }, payload: { entity: string; value: string; after: boolean }): void {
    commit('shellPropertyChanged', payload);
  },
  updateWorkingTimesEntity({ commit }, payload) {
    commit('updateWorkingTimesEntity', payload);
  },
  setPreparingOrdersNumber({ commit }, payload) {
    commit('setPreparingOrdersNumber', payload);
  },
  newOrderArrived({ commit }, order: IOrderDetail) {
    commit('newOrderArrived', order);
  },
};
